import React, { useState } from 'react';
import { ImageModelResponseType } from '@/components/admin/QuestionImage/utils';
import Select from 'react-select-5';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_image_model_path } from '@/modules/routes';

interface DisplayLocationDropdownProps {
  afterSubmit: () => any;
  imageModel: ImageModelResponseType;
  inImageCard?: boolean;
  label?: string;
  selectStyles?: object;
}

type DisplayLocationType = 'background' | 'stimulus' | 'clipart';

const DISPLAY_OPTIONS = [
  { label: 'Background', value: 'background' },
  { label: 'Prompt', value: 'stimulus' },
  { label: 'Drawing Clip Art', value: 'clipart' },
] as const;

const SELECTABLE_OPTIONS = DISPLAY_OPTIONS.filter(opt => opt.value !== 'clipart');

const useDisplayLocationMutation = (afterSubmit: () => any, imageModel: ImageModelResponseType) => useMutation({
  mutationFn: async ({ type }: { type: DisplayLocationType }) => {
    const data = { image_model: { id: imageModel.id, media_meta: { ...imageModel.media_meta, type } } };

    return axios.put(plato_api_image_model_path(imageModel.id), data).then(res => res.data);
  },
  onSuccess: () => afterSubmit(),
});

export default function DisplayLocationDropdown({
  afterSubmit,
  imageModel,
  inImageCard,
  label = 'Display Location:',
  selectStyles,
}: DisplayLocationDropdownProps) {
  const currentDropdownValue = DISPLAY_OPTIONS.find(opt => opt.value === imageModel.media_meta.type);
  const [dropdownValue, setDropdownValue] = useState(currentDropdownValue);
  const { mutate } = useDisplayLocationMutation(afterSubmit, imageModel);
  const isDisabled = dropdownValue?.value === 'clipart';

  const handleChange = (opt) => {
    mutate({ type: opt.value });
    setDropdownValue(opt);
  };

  if (inImageCard) {
    return (
      <div className="tw-flex tw-flex-col">
        <span className="tw-inline-block tw-font-bold tw-pb-1">{label}</span>
        <Select
          isDisabled={isDisabled}
          options={SELECTABLE_OPTIONS}
          styles={selectStyles}
          value={dropdownValue}
          onChange={handleChange}
        />
      </div>
    );
  }

  return (
    <>
      <span className="tw-inline-block tw-font-bold tw-pb-1">{label}</span>
      <Select
        isDisabled={isDisabled}
        options={SELECTABLE_OPTIONS}
        value={dropdownValue}
        onChange={handleChange}
      />
    </>
  );
}
